import React from "react";
import AboutSection from "../components/landing_page_components/AboutSection";
import MyAppBar from "../components/landing_page_components/appbar/AppBar";
import MyTopSection from "../components/landing_page_components/TopSection";
import { Container } from "@mui/material";
import { styled } from "@mui/system";

const StyledContainer = styled(Container)(({ theme }) => ({
  width: "80%",
  [[theme.breakpoints.between("xs", "md")]]: {
    width: "100%",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    width: "90%",
  },
  [theme.breakpoints.up("lg")]: {
    width: "80%",
  },
}));

const LandingPage = () => {
  return (
    <>
      <MyAppBar />
      <StyledContainer disableGutters fixed maxWidth="false">
        <MyTopSection />
        <AboutSection />
      </StyledContainer>
    </>
  );
};

export default LandingPage;
